import {Component, Inject, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {NgIf} from '@angular/common';
import {DialogHeaderComponent} from 'frontier/browserkit/src/lib/components/dialog-header/dialog-header.component';

@Component({
  selector: 'lib-pdf-dialog',
  templateUrl: './pdf-dialog.component.html',
  styleUrl: './pdf-dialog.component.css',
  standalone: true,
  imports: [DialogHeaderComponent, NgIf, MatProgressSpinner]
})
export class PdfDialogComponent {

  private sanitizer = inject(DomSanitizer);

  pdfSrc: SafeResourceUrl;

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: Blob
  ) {
    const url = URL.createObjectURL(data);
    this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
